import { useNavigation } from '@react-navigation/native'
import { NativeStackNavigationProp } from '@react-navigation/native-stack'
import {
  Button,
  Flex,
  FormControl,
  Heading,
  Image,
  Text,
  VStack,
} from 'native-base'
import { useState } from 'react'
import { useWindowDimensions } from 'react-native'
import { useMobileBreakpoint } from '../../../../domain/services/useBreakpoint'
import { useAuthContext } from '../../providers/AuthProvider'
import { GuestScreenParams } from '../../screens/GuestScreen'
import FormInput from '../_shared/form/FormInput'

const Wave = require('../../assets/images/login/wave-forgot-pw.png')
const WaveIsSent = require('../../assets/images/login/wave-check-pw.png')

const ForgotPasswordForm = () => {
  const navigation =
    useNavigation<NativeStackNavigationProp<GuestScreenParams>>()
  const { resetPassword } = useAuthContext()
  const isMobile = useMobileBreakpoint()
  const { width } = useWindowDimensions()

  const [isSent, setIsSent] = useState(false)
  const [email, setEmail] = useState('')
  const isValidEmail = email.match(/\S+@\S+\.\S+/) ? true : false

  const emailValidation = () =>
    new Promise((resolve, reject) => {
      if (isValidEmail) resolve(null)
      else
        reject(
          'Uh oh - a valid email address requires an @ followed by the domain.'
        )
    })

  const doResetPassword = () => {
    resetPassword(email).then(() => {
      setIsSent(true)
    })
  }

  const title = isSent ? 'Check your email' : 'Forgot your password'
  const description = isSent
    ? 'Please check your email for instructions to reset your password.'
    : 'Enter the email address associated with your account and we’ll email you instructions to reset your password.'
  const buttonText = isSent ? 'Resend email' : 'Email instructions'

  return (
    <>
      <Image
        source={isSent ? WaveIsSent : Wave}
        alt="Wave"
        position="absolute"
        top={0}
        left="0"
        width={width}
        height={'120px'}
        borderTopRadius={isMobile ? 0 : '3xl'}
        key={isSent ? 'email-is-sent' : 'email-is-not-sent'}
      />

      <VStack h="100%" w="100%" bg="canaba.sand">
        <Heading fontSize="24px" mt="3" color="primary.900">
          {title}
        </Heading>
        <Text
          mt="3"
          w="280px"
          minH="64px"
          lineHeight="25px"
          color="primary.900">
          {description}
        </Text>

        <VStack mt="7" space={3}>
          {isSent ? (
            <>
              <Text color="primary.900" fontSize="18px">
                {email}
              </Text>
              <Text
                mt="3"
                w="280px"
                minH="64px"
                lineHeight="25px"
                color="primary.900">
                Be sure to check your spam folder in case you can't find it.
              </Text>
            </>
          ) : (
            <FormControl>
              <FormInput
                bg="white"
                label="Email"
                defaultValue={email}
                onChangeText={setEmail}
                keyboardType="email-address"
                validation={emailValidation}
                autofocus
                inputAccessoryViewID={undefined}
                inputParamRef={undefined}
              />
            </FormControl>
          )}

          <Flex alignItems="center">
            {isSent && (
              <Text color="text.500" mb="-5px">
                Can't find it?
              </Text>
            )}
            <Button
              w="100%"
              mt={isSent ? '0' : '2'}
              onPress={doResetPassword}
              isDisabled={!isValidEmail}
              variant={isSent ? 'link' : 'solid'}>
              <Text
                color={isSent ? 'secondary.700' : 'white'}
                underline={isSent ? true : false}>
                {buttonText}
              </Text>
            </Button>
          </Flex>
        </VStack>
      </VStack>
    </>
  )
}

export default ForgotPasswordForm
